import { NavBarEvent, OpenNavBarDetail } from 'components/layout/NavBar/types';

export const NAVBAR_EVENT_NAME = 'NAVBAR_EVENT';

const createNavBarEvent = (data: OpenNavBarDetail): NavBarEvent => {
  return new CustomEvent(NAVBAR_EVENT_NAME, {
    detail: { ...data },
  });
};

const fireEventOnBody = (event: NavBarEvent): void => {
  if (!window?.document?.body) {
    console.error("Can't fire CustomEvent");
  }
  window.document.body.dispatchEvent(event);
};

export const openNavBarFn = (isVisible: boolean): void => {
  fireEventOnBody(createNavBarEvent({ isVisible: isVisible }));
};
